import { render } from "./FoldseekSearchButton.vue?vue&type=template&id=e7f1c2f0"
import script from "./FoldseekSearchButton.vue?vue&type=script&lang=js"
export * from "./FoldseekSearchButton.vue?vue&type=script&lang=js"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__